import { REDUCE_TRIAGE_POLICIES } from '../../constants/actions/policies';

export function reduceTriagePolicies(payload) {
    return {
        type: REDUCE_TRIAGE_POLICIES,
        payload,
    };
}
